/**
 * Native app build info and external-link opening (src/platform/).
 * Version is null on web, where no store build exists.
 */

import { isNativePlatform } from './detection'

/** The installed native app's version, or null on web or when unreadable. */
export async function getNativeAppVersion(): Promise<string | null> {
  if (!isNativePlatform()) return null
  try {
    const { App } = await import('@capacitor/app')
    return (await App.getInfo()).version
  } catch {
    return null
  }
}
